export const FeatureFlags = {
  WellnessLandingTreatment: 'WELLNESS_LANDING_V2',
  VetChatLandingTreatment: 'VET_CHAT_LANDING_V2',
  CityPageLandingTreatment: 'CITY_PAGE_LANDING_V2',
  DirectBookingFlowTreatment: 'DIRECT_BOOKING_V2',
  BoardingLandingCopy: 'BOARDING_LANDING_COPY',
  WebPcgPreferenceTest: 'WEB_PCG_PREFERENCE_TEST',
} as const;
